(function() {
    const isDebug = false;
    const isTesting = false;

    const baseStyles = [
      "color: #fff",
      "background-color: #2759e1",
      "padding: 2px 8px",
      "border-radius: 4px",
    ].join(";");
    function consoleLog() {
      if (window.console && isDebug === true) {
        console.log("%cNP-CUSTOM-IPAPI", baseStyles, ...Array.prototype.slice.call(arguments));
      }
    }
    var fullUrl = window.location.href;
    var urlAfterDomain = window.location.pathname;
    var segments = urlAfterDomain.split('/');
    var productURL = segments[2];  
    var articleURL = segments[3]; 

    function regionProductUpdate() { 
        //consoleLog('Calling regionProductUpdate()');
        $('#Slide-template--16940375179308__main-31199647989804 > div > modal-opener > div.product__media.media.media--transparent > img').attr('src', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-1_1024x.jpg?v=6191048593938707027');
        $('#Slide-template--16940375179308__main-31199647989804 > div > modal-opener > div.product__media.media.media--transparent > img').attr('srcset', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-1_1024x.jpg?v=6191048593938707027 600w, //www.natpat.com/cdn/shop/files/indiana-bp-pack-1_1024x.jpg?v=6191048593938707027 1200w');

        $('#Slide-template--16940375179308__main-31199648153644 > div > modal-opener > div.product__media.media.media--transparent > img').attr('src', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-2_1024x.jpg?v=7376957592198990846');
        $('#Slide-template--16940375179308__main-31199648153644 > div > modal-opener > div.product__media.media.media--transparent > img').attr('srcset', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-2_1024x.jpg?v=7376957592198990846 600w, //www.natpat.com/cdn/shop/files/indiana-bp-pack-2_1024x.jpg?v=7376957592198990846 1200w');

        $('#Slide-template--16940375179308__main-31199648088108 > div > modal-opener > div.product__media.media.media--transparent > imgg').attr('src', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-3_1024x.jpg?v=15128557056251007312');
        $('#Slide-template--16940375179308__main-31199648088108 > div > modal-opener > div.product__media.media.media--transparent > img').attr('srcset', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-3_1024x.jpg?v=15128557056251007312 600w, //www.natpat.com/cdn/shop/files/indiana-bp-pack-3_1024x.jpg?v=15128557056251007312 1200w');

        $('#Slide-template--16940375179308__main-31199648186412 > div > modal-opener > div.product__media.media.media--transparent > img').attr('src', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-4_1024x.jpg?v=1673339863015780960');
        $('#Slide-template--16940375179308__main-31199648186412 > div > modal-opener > div.product__media.media.media--transparent > img').attr('srcset', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-4_1024x.jpg?v=1673339863015780960 600w, //www.natpat.com/cdn/shop/files/indiana-bp-pack-4_1024x.jpg?v=1673339863015780960 1200w');

        $('#Slide-template--16940375179308__main-31199648907308 > div > modal-opener > div.product__media.media.media--transparent > img').attr('src', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-main_1024x.jpg?v=6684428467451349385');
        $('#Slide-template--16940375179308__main-31199648907308 > div > modal-opener > div.product__media.media.media--transparent > img').attr('srcset', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-main_1024x.jpg?v=6684428467451349385 600w, //www.natpat.com/cdn/shop/files/indiana-bp-pack-main_1024x.jpg?v=6684428467451349385 1200w');

        $('#Slide-template--16940375179308__main-31199648219180 > div > modal-opener > div.product__media.media.media--transparent > img').attr('src', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-main1_1024x.jpg?v=15421382706747316639');
        $('#Slide-template--16940375179308__main-31199648219180 > div > modal-opener > div.product__media.media.media--transparent > img').attr('srcset', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-main1_1024x.jpg?v=15421382706747316639 600w, //www.natpat.com/cdn/shop/files/indiana-bp-pack-main1_1024x.jpg?v=15421382706747316639 1200w');

        $('#Slide-template--16940375179308__main-31199648710700 > div > modal-opener > div.product__media.media.media--transparent > img').attr('src', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-main2_1024x.jpg?v=5085908323881956420');
        $('#Slide-template--16940375179308__main-31199648710700 > div > modal-opener > div.product__media.media.media--transparent > img').attr('srcset', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-main2_1024x.jpg?v=5085908323881956420 600w, //www.natpat.com/cdn/shop/files/indiana-bp-pack-main2_1024x.jpg?v=5085908323881956420 1200w');
        
        $('#Slide-template--16940375179308__main-31199648022572 > div > modal-opener > div.product__media.media.media--transparent > img').attr('src', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-main3_1024x.jpg?v=14421654535122585993');
        $('#Slide-template--16940375179308__main-31199648022572 > div > modal-opener > div.product__media.media.media--transparent > img').attr('srcset', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-main3_1024x.jpg?v=14421654535122585993 600w, //www.natpat.com/cdn/shop/files/indiana-bp-pack-main3_1024x.jpg?v=14421654535122585993 1200w');
    
    }  
    function regionArticleUpdate() { 
        //consoleLog('Calling regionArticleUpdate()');
        $('.in-hidden').hide();
        $('article > div.article-template__content.page-width.page-width--narrow.rte.scroll-trigger.animate--slide-in > div:nth-child(8) > img').attr('src', '//www.natpat.com/cdn/shop/files/indiana-bp-pack-main1_1024x.jpg?v=15421382706747316639');

    }


    function regionGeneralUpdate() { 
       // consoleLog('Calling regionGeneralUpdate()');
    $('.remove-deet, .hide-storage-disposal, .remove-direction, .in-hidden').hide();
    $('.in-only').attr('style', 'display: block !important');
    $('.replace-hours').text('after 45 minutes');
    $('.replace-hours').css('color', '#212529');

    $('.remove-allergies').hide(); 
    $('.as-directed').text(', when used as directed');
    $('.text-oil').text('oil');
    $('.storage-disposal').text('Store in a cool, dry place, away from food and drink, and out of the reach of children. Best used within 6 months of opening.');

    $('.included .boxes').css('background-image', 'url(//www.natpat.com/cdn/shop/files/BuzzPatch-60-current-center-ind.jpg?v=10584769209168754054)');
    
    }

    function regionBPAdultUpdate() { 
       // consoleLog('Calling regionBPAdultUpdate()');
        $('.wi-hidden').hide();
        $('.as-directed').text(', when used as directed'); 
    }


    async function IPAPICheck() {
        consoleLog('Calling IPAPICheck()');
        
    }

    async function checkLocation() {
        consoleLog('Calling checkLocation()');
        try {
            let checkUrl = 'https://ipapi.natpat.com/';
            const response = await fetch(checkUrl);
            if (!response.ok) {
            console.error('Error fetching JSON data:', response);
            return;
            }
            const jsonData = await response.json();
            consoleLog('Fetched JSON data:', jsonData);

            // Gather all region/state values from stateConfidence and loc
            const stateRegions = [
                ...(Array.isArray(jsonData?.stateConfidence) ? jsonData.stateConfidence.map(sc => sc.region) : [])
            ].filter(Boolean);

            if (stateRegions.length === 0) {
                consoleLog('No user state found');
                return;
            }
            consoleLog('User state found:', stateRegions);

            if (stateRegions.includes('Indiana') || stateRegions.includes('New Mexico')) {
                //window.location.href= '/pages/buzzpatch-indiana'; 
                regionGeneralUpdate()
                if (productURL === 'buzzpatch-bundles' ) {
                    regionProductUpdate() 
                } 
                if (articleURL === 'best-mosquito-patches-for-kids' ) {
                    regionArticleUpdate() 
                }  
            } 

            if (stateRegions.includes('Wisconsin') ) {
                if (productURL === 'adult-buzzpatch-mosquito-repellent-patches' || productURL === 'buzzpatch-bundles') {
                    regionBPAdultUpdate() 
                }  
            }
        } catch (error) {
            console.error('Error fetching JSON data:', error);
        }
    }
    

    async function regionBasedUpdate() {
        consoleLog('Calling regionBasedUpdate()');
        var userCountry = Shopify && Shopify.country ? Shopify.country : '';  
        consoleLog('userCountry: ' + userCountry);
        if (userCountry === 'US') {
            //consoleLog(userCountry); 
            if (productURL == 'buzzpatch-bundles' || productURL == 'buzzpatch' || articleURL == 'best-mosquito-patches-for-kids' || productURL == 'adult-buzzpatch-mosquito-repellent-patches') { 
                // IPAPICheck();
                
                await checkLocation();
            }
        } else {
        //consoleLog('You are from other country: ' + userCountry);
        } 
    }

    regionBasedUpdate();
})();
